export function init_classic_menu_resize() {
  var mobile_nav = document.querySelector(".mobile-nav");
  var desktop_nav = document.querySelector(".desktop-nav");
  var main_nav = document.querySelector(".main-nav");

  if (!mobile_nav || !desktop_nav || !main_nav) return;

  mobile_nav.setAttribute("aria-expanded", "false");

  // Mobile menu max height
  var desktop_nav_ul = document.querySelector(".desktop-nav > ul");
  if (desktop_nav_ul) {
    desktop_nav_ul.style.maxHeight =
      window.innerHeight - main_nav.offsetHeight - 20 + "px";
  }

  // Mobile menu style toggle
  if (window.innerWidth <= 1024) {
    main_nav.classList.add("mobile-on");
    if (!mobile_nav.classList.contains("active")) {
      desktop_nav.style.display = "none";
    }
  } else if (window.innerWidth > 1024) {
    main_nav.classList.remove("mobile-on");
    desktop_nav.style.display = "block";
  }
}
